import { useEffect, useState } from 'react';

import { logger } from '@azure/storage-blob';

import { ReleaseNotesApi, IReleaseNote } from '@/api/api.release.notes';
import { useUserStore } from '@/store';

export function useReleaseNotesModal() {
  const { user } = useUserStore();
  const [latestRelease, setLatestRelease] = useState<IReleaseNote | null>(null);
  const [shouldShowPopup, setShouldShowPopup] = useState(false);

  useEffect(() => {
    const fetchLatestRelease = async () => {
      try {
        const response = await ReleaseNotesApi.getLatestReleaseNote();
        const latest = response.data;

        if (!latest?.version) return;

        setLatestRelease(latest);

        const seenVersion = user?.settings?.lastSeenReleaseVersion;
        if (latest.version !== seenVersion) {
          setShouldShowPopup(true);
        }
      } catch (err) {
        logger.error('Failed to fetch latest release note', err);
      }
    };

    if (user?._id) {
      fetchLatestRelease();
    }
  }, [user?._id]);

  return {
    shouldShowPopup,
    latestRelease,
    setShouldShowPopup,
  };
}
